import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AppConstant, RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';

@Injectable({
  providedIn: 'root',
})
export class SponsorApiService {
  constructor(
    private http: HttpClient,
    private downloadHelper: downloadHelper
  ) { }

  saveSponsorDetails(data: any) {
    return lastValueFrom(this.http.post(`/sponsor/save`, data));
  }
  getList(ev: any, type = 'ACTIVE') {
    return lastValueFrom(this.http.post(`/sponsor/getList/${type}`, ev));
  }

  updateRequest(id: string | number, data: any) {
    return lastValueFrom(this.http.post(`/sponsor/updateRequest/${id}`, data));
  }

  sponsorshipUpdateRequest(id: string | number, data: any) {
    return lastValueFrom(
      this.http.post(`/sponsor/updateSponsorship/${id}`, data)
    );
  }

  getById(id: any) {
    return lastValueFrom(this.http.get(`/sponsor/getById/${id}`));
  }
  getBasic(id: any) {
    return lastValueFrom(this.http.get(`/sponsor/getBasic/${id}`));
  }

  getDetails(id: any) {
    return lastValueFrom(this.http.get(`/sponsor/getDetails/${id}`));
  }

  getRememberAll(ev: any = {}, type = 'BIRTHDAY', cat = '0') {
    return lastValueFrom(
      this.http.post(`/sponsor/getRememberAll/${type}/${cat}`, ev)
    );
  }
  troubleshoot(id: any){
    return lastValueFrom(this.http.post(`/sponsorship/troubleshoot/${id}`,{}));
  }

  search(ev: any = {}) {
    return lastValueFrom(
      this.http.post(`/sponsor/search`, ev)
    );
  }
  searchAllotment(ev: any = []) {
    return lastValueFrom(
      this.http.post(`/sponsorship/searchAllotment`, ev)
    );
  }

  saveSponsorShip(data: any) {
    return lastValueFrom(this.http.post(`/sponsor/saveSponsorship`, data));
  }

  // sponsorshipGetList(ev: any) {
  //   return lastValueFrom(this.http.post(`/sponsorship/getList/ACTIVE`, ev));
  // }
  sponsorshipGetList(ev: any, type = 'ACTIVE') {
    return lastValueFrom(this.http.post(`/sponsorship/getList/${type}`, ev));
  }

  getAllPending(id: any) {
    return lastValueFrom(this.http.get(`/sponsorship/getAllPending/${id}`));
  }

  saveAllotment(data: any) {
    return lastValueFrom(this.http.post(`/sponsorship/saveAllotment`, data));
  }

  updateSponsorshipRequest(id: string | number | Array<any>, data: any) {
    if (Array.isArray(id)) {
      id = id.join(',');
    }
    return lastValueFrom(
      this.http.post(`/sponsorship/updateRequest/${id}`, data)
    );
  }

  getSponsorshipDetails(id: any) {
    return lastValueFrom(this.http.get(`/sponsorship/getDetails/${id}`));
  }
  getSponsorship(id: any) {
    return lastValueFrom(this.http.get(`/sponsorship/get/${id}`));
  }

  reliveSponsorship(id: any, data: any) {
    return lastValueFrom(this.http.post(`/sponsorship/relive/${id}`, data));
  }

  getSponsorshipAllotment(ref_id: any, module: any) {
    return lastValueFrom(
      this.http.get(`/sponsorship/getListRefAllotment/${ref_id}/${module}`)
    );
  }

  getActiveAllotment(ref_id: any, module: number | string) {
    return lastValueFrom(
      this.http.get(`/sponsorship/getActiveRefAllotment/${ref_id}/${module}`)
    );
  }

  getListRefSponsorByLang(ref_id: any, lang: any) {
    const tbl_ext = JSON.stringify(ref_id);
    return lastValueFrom(
      this.http.get(`/sponsorship/getListRefSponsorByLang/${tbl_ext}/${lang}`)
    );
  }
  getListSponsorByRef(ref_id: any, module: number) {
    return lastValueFrom(
      this.http.get(`/sponsorship/getListSponsorByRef/${ref_id}/${module}`)
    );
  }
  getListAllotment(ev: any) {
    return lastValueFrom(this.http.post(`/sponsorship/getListAllotment`, ev));
  }
  updateEmailAllotment(id: any, data: any) {
    return lastValueFrom(
      this.http.post(`/sponsorship/updateEmail/${id}`, data)
    );
  }

  sentMail(data: any) {
    return lastValueFrom(this.http.post(`sponsorship/sentMail`, data));
  }
  notifyMail(id: any) {
    return lastValueFrom(this.http.post(`sponsorship/notifyMail/${id}`,{}));
  }

  getListGift(ev: any) {
    return lastValueFrom(this.http.post(`/sponsorGift/getList/ACTIVE`, ev));
  }
  getGiftData(id: any) {
    return lastValueFrom(this.http.get(`/sponsorGift/getDetails/${id}`));
  }
  saveGift(data: any) {
    return lastValueFrom(this.http.post(`/sponsorGift/save`, data));
  }
  reliveGift(id: any) {
    return lastValueFrom(this.http.delete(`/sponsorGift/relive/${id}`));
  }
  // donation
  getDonationList(ev: any) {
    return lastValueFrom(this.http.post(`/donation/getList`, ev));
  }
  saveDonation(d: any) {
    return lastValueFrom(this.http.post(`/donation/save`, d));
  }
  updateDonationFull(id: any, d: any) {
    return lastValueFrom(this.http.post(`/donation/update/${id}`, d));
  }
  getDonationApi(id: any) {
    return lastValueFrom(this.http.get(`/sponsor/getAllDonation/${id}`));
  }
  getDonationById(id: any) {
    return lastValueFrom(this.http.get(`/donation/getById/${id}`));
  }
  getDonationSponsorShip(ev: any) {
    return lastValueFrom(this.http.post(`/donation/getSponsorship`, ev));
  }
  updateDonationRequest(id: any, data: any) {
    return lastValueFrom(this.http.post(`/donation/updateDonation/${id}`, data));
  }
  // Online-donation payment status (Payment Status, separate from the donation's own
  // Donation Status) - see backend Services\Payment\DonationPaymentService.
  initiateOnlineDonation(data: any) {
    return lastValueFrom(this.http.post(`/donation/online/initiate`, data));
  }
  verifyDonationPayment(id: any, data: any = {}) {
    return lastValueFrom(this.http.post(`/donation/${id}/verify`, data));
  }
  failDonationPayment(id: any, data: any = {}) {
    return lastValueFrom(this.http.post(`/donation/${id}/fail`, data));
  }
  cancelDonationPayment(id: any) {
    return lastValueFrom(this.http.post(`/donation/${id}/cancel`, {}));
  }
  refundDonationPayment(id: any, reason: string) {
    return lastValueFrom(this.http.post(`/donation/${id}/refund`, { reason }));
  }
  //donation allotment assign info
  saveDonationAllotment(data: any) {
    return lastValueFrom(this.http.post(`/donation/allotment`, data));
  }
  getDonationAllotmentList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.post(`/donation/allotment/getList`, ev));
  }
  getDonationReportStats() {
    return lastValueFrom(this.http.get(`/donation/getReportStats`));
  }
  getSponsorshipCount() {
    return lastValueFrom(
      this.http.get(`/sponsorship/getTotalSponsorshipsCount`)
    );
  }
  getSponsorshipStats(startDate: string, endDate: string) {
    return lastValueFrom(
      this.http.post(`/sponsorship/getStats`, { startDate, endDate })
    );
  }
  exportBirthday(ev: any, type: any, cat: any) {
    const url = `/sponsor/exportRemember/${type}/${cat}`;
    const fileName = `${AppConstant.ORG_NAME}-SPONSOR-${type}` || '';
    return this.downloadHelper.downloadApi(url, 'POST', fileName, ev);
  }

  checkRequestExists = (
    data: any,
    type: 'SPONSORSHIP' = 'SPONSORSHIP'
  ): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      console.log(data);
      if (+(data.modify_request || 0) == 1) {
        resolve(false);
        return;
      }
      this.getSponsorship(data.id)
        .then((res: ResponseData | any | any) => {
          if (res.statusCode == RESPONSE_CODE.SUCCESS) {
            if (res.result) {
              if (+res.result.modify_request == 0) {
                resolve(true);
              }
            }
          }
          resolve(false);
        })
        .catch((err) => {
          reject(true);
        });
    });
  };
}
